module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/download_teams_desktop.8b19bcf718049556d444cc8b092c8921.svg";